<!--
 * @Author: your name
 * @Date: 2021-08-25 10:30:01
 * @LastEditTime: 2023-04-17 16:29:14
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南\src\modules\fire\components\deviceChange.vue
-->
<template>
  <!-- 选择楼栋 -->
  <div class="dialog-app-panel" :class="showBuilding ? 'dialog-show' : ''">
    <app-panel
      :isExpand="showBuilding"
      :title="dialogType == 1 ? '选择楼层及设备位置' : '选择楼层'"
      :transparent="true"
      :width="1000"
      isScreen
      @cancel="camCancleOpt"
      @screen="getCanvasWH"
    >
      <!--左侧楼栋树-->
      <div class="flex-container">
        <div class="flex-valign left-tree">
          <!-- <div class="left-type_area"> -->
          <div class="tree-container" style="height: 100%">
            <div class="area-title">楼栋信息</div>
            <div class="area-search">
              <el-input
                v-model="searchString"
                clearable
                placeholder="请输入搜索关键字"
                prefix-icon="el-icon-search"
              >
              </el-input>
            </div>
            <el-scrollbar class="scroll-bar-view" style="height: calc(100% - 90px)">
              <el-tree
                v-if="showTree"
                ref="tree"
                class="tree-content"
                :data="treeData"
                :expand-on-click-node="false"
                node-key="id"
                render-after-expand
                :load="asyncLoadNode"
                :lazy="lazyLoad"
                :props="treeProps"
                :highlight-current="true"
                :filter-node-method="filterNode"
                @node-click="nodeClick"
              >
                <div
                  class="custom-tree-node"
                  :title="node.label"
                  slot-scope="{ node, data }"
                >
                  <i :class="iconList[data.type]"></i>
                  <div class="ml10 ell tree-label">{{ node.label }}</div>
                </div>
              </el-tree>
            </el-scrollbar>
            <!-- </div> -->
          </div>
        </div>
        <!--右侧展示图纸-->
        <!-- 右侧图纸 -->
        <div class="right-img">
          <div class="canvasMain">
            <div
              class="canvasMainT"
              :style="{
                width: vW + '%',
                height: vH + '%',
                marginTop: getMarginTop + 'px',
                marginLeft: getMarinLeft + 'px',
              }"
            >
              <img
                id="building-img"
                :src="
                  rootDefaultDrawing
                    ? '/images/theme/newDark/default-drawing1.jpg'
                    : imgUrl
                "
              />
              <canvas
                id="dialog-mycanvas"
                @mousewheel="mouseScroll"
                @DOMMouseScroll="mouseScroll"
                @mousedown="handleDomMoveStart"
                :width="cW"
                :height="cH"
              ></canvas>
            </div>
          </div>
        </div>
        <div class="marTip" v-if="dialogType == 1">
          <!-- <span> 选中【 {{ areaCopy.name }} 】图纸预览 </span> -->
          <span> 【 缩放比例 {{ vW }}% 】 </span>
          <!-- 【相对坐标 X：{{ x }} ，Y：{{ y }} 】 -->
        </div>
        <img
          class="cam"
          ref="checkImg"
          style="position: absolute; visibility: hidden"
          src="../../../../public/images/theme/newDark/deviceCheck.png"
          width="20"
          height="20"
          alt=""
        />
      </div>
      <!--操作按钮-->
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="camCancleOpt">取消</el-button>
        <el-button type="primary" @click="camConfirmOpt">确定</el-button>
      </span>
      <!-- </el-dialog> -->
    </app-panel>
  </div>
</template>

<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import deviceMap from "@src/modules/cameraList/components/deviceMap";
import { api } from "../api";
import { Bus } from "$utils";
export default {
  mixins: [deviceMap],
  watch: {
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
    searchString: {
      handler(val) {
        this.$refs.tree.filter(val);
      },
    },
  },
  components: {
    appPanel,
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
  },
  data() {
    return {
      iconList: {
        1: "iconfont-lunan icon-lunan-loudongguanli",
        2: "iconfont-lunan icon-lunan-louceng",
      },
      dialogType: 1,
      treeData: [],
      isOther: true,
      showBuilding: false,
      searchString: "",
      rootDefaultDrawing: true,
      showTree: true,
      lazyLoad: false,
      devInData: {},
      cW: 0,
      cH: 0,
      canvasList: [],
      areaCopy: {},
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
    };
  },
  mounted() {
    this.queryBuildingTree();
  },
  methods: {
    changeCanvas(e) {
      let xh = e.offsetX / this.cW;
      let yh = e.offsetY / this.cH;
      let newW = document.querySelector(".right-img .canvasMainT").offsetWidth;
      let newH = document.querySelector(".right-img .canvasMainT").offsetHeight;
      let moveX = newW * xh - e.offsetX;
      let moveY = newH * yh - e.offsetY;
      this.marginTop = Math.round(this.marginTop - moveY);
      this.marginLeft = Math.round(this.marginLeft - moveX);
    },
    // 打开楼层图纸：如果type:1 默认可选择图纸和位置，type:2 仅仅可选择图纸
    open(item, type = 1) {
      console.log(item);
      this.dialogType = type;
      if (item) {
        // this.clearCanvas("dialog-mycanvas");
        this.canvasList[0] = item;
        this.areaCopy = {
          id: item.buildingCode,
          name: "",
        };
        this.devInData.fileCode = item.fileCode;
        this.imgUrl = this.getImgPath(this.devInData.fileCode);
      }
      this.showBuilding = true;
      if (type != 1) {
        return;
      }
      this.$nextTick(() => {
        this.getCanvasWH();
        this.clickPoints();
      });
    },
    close() {
      this.showBuilding = false;
      this.cW = 0;
      this.cH = 0;
      this.areaCopy = {};
      this.canvasList = [];
      this.clearCanvas("dialog-mycanvas");
    },
    clickPoints() {
      let that = this;
      var canvas = document.querySelector(".right-img  .canvasMainT");
      canvas.addEventListener("click", function (e) {
        that.showCamImg(e);
      });
    },
    // 画布点击回调
    showCamImg(e) {
      this.clearCanvas("dialog-mycanvas");
      this.canvasList = [];
      this.x = e.offsetX;
      this.y = e.offsetY;
      let ctx = this.initCanvas("dialog-mycanvas");
      let img = this.$refs.checkImg;
      ctx.drawImage(img, Math.round(this.x - 10), Math.round(this.y - 10), 25, 25);
      this.canvasList.push({
        width: this.cW, //原始大小
        height: this.cH, //原始大小
        x: e.offsetX,
        y: e.offsetY,
        abscissa: e.offsetX,
        ordinate: e.offsetY,
      });
    },
    // 获取canvas father W H
    getCanvasWH() {
      this.cH = document.querySelector(".right-img  .canvasMainT").offsetHeight;
      this.cW = document.querySelector(".right-img  .canvasMainT").offsetWidth;
      if (this.canvasList.length) {
        let ctx = this.initCanvas("dialog-mycanvas");
        let img = this.$refs.checkImg;
        this.canvasList.forEach((el) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          this.$nextTick(() => {
            ctx.drawImage(
              img,
              Math.round(el.abscissa * wb - 10),
              Math.round(el.ordinate * hb, -10),
              25,
              25
            );
          });
        });
      }
    },
    camConfirmOpt() {
      if (this.dialogType == 1) {
        if (!this.canvasList[0] || !this.areaCopy.id) {
          this.$message.warning("请选择楼层位置及在图纸标记");
          return;
        }
        this.$emit("confirmChange", this.canvasList, this.areaCopy);
      } else {
        if (!this.areaCopy.id) {
          this.$message.warning("请选择楼层");
          return;
        }
        this.$emit(
          "confirmChange",
          this.areaCopy,
          this.devInData.fileCode,
          this.dialogType
        );
        this.close();
      }
    },
    camCancleOpt() {
      this.close();
      this.showBuilding = false;
    },
    queryBuildingTree() {
      this.$fetch(api.cms.queryBuildingTree).then((res) => {
        const result = this.menusDataPro(res.returnObj);
        this.treeData = Object.freeze(result);
      });
    },
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    // 点击节点
    nodeClick(data) {
      console.log(data);
      if (data.type == 1) {
        this.areaCopy = {};
        this.parentCode = "";
        this.$message.warning("请选择楼层");
        return;
      }
      // 清空已存在的数据和画布
      this.clearCanvas("dialog-mycanvas");
      this.canvasList = [];
      this.x = this.y = "";
      // copy选中数据
      this.areaCopy = {
        name: data.name,
        id: data.id,
      };
      this.parentCode = data.parentCode;
      if (!data.fileCode) {
        this.rootDefaultDrawing = true;
      } else {
        this.rootDefaultDrawing = false;
        this.devInData.fileCode = data.fileCode;
        this.imgUrl = this.getImgPath(this.devInData.fileCode);
      }
      this.$forceUpdate();
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.buildingCode;
          entity.name = item.buildingName;
          entity.parentCode = item.parentCode;
          entity.type = item.type;
          entity.fileCode = item.fileCode;
          entity.desc = item.desc;
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList;
          if (item.subBuildingList) {
            entity.children = self.menusDataPro(item.subBuildingList);
          }
          result.push(entity);
        });
        return result;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-app-panel {
  //   pointer-events: none;
  z-index: 10;
}
.flex-container {
  display: flex;
  height: 100%;
  .left-tree {
    // background: rgba(1/3, 18, 28, 0.7);
    // background: #181f2e;
    background: #3b404c;
    flex: 1;
    max-width: 350px;
  }
  .area-title {
    margin: 10px 0 16px 10px;
    border-left: 5px solid #407aee;
    padding-left: 10px;
    font-size: 14px;
    // color: #e8eaee;
  }

  :deep .el-tree-node__content {
    height: 32px;
    line-height: 32px;
    background: #3b404c;
  }
  .custom-tree-node {
    width: 100%;
    height: 32px;
    line-height: 32px;
    display: flex;
    .tree-label {
      max-width: 100%;
    }
    .area-operator {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .area-search {
    margin: 12px;
  }

  .right-img {
    // margin-top: 35px;
    margin-left: 12px;
    flex: 2;
    .title {
      margin: 10px 0;
      justify-content: space-between;
      display: flex;
    }
    #building-img {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .canvasMain {
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba(128, 128, 128, 0.5);
    overflow: hidden;
    .canvasMainT {
      position: absolute;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
      }
      canvas {
        position: absolute;
      }
    }
  }
  .marTip {
    position: absolute;
    right: 0%;
    background: rgba(13, 18, 28, 0.7);
    padding: 5px 10px;
    // position: absolute;
    // text-align: center;
    // right: 30px;
    // bottom: 20px;
  }
}
</style>
